import { IFlowEventData } from 'types/analytics';

export const TEXT_KEYS = {
    EVENT_DATES: 'redeem-success__event-dates',
    REDEEM_SUCCESS_TITLE: 'redeem-success__title',
    REDEEM_SUCCESS_CONGRATS_MESSAGE: 'redeem-success__congratulation-message-single',
};

export const SUCCESS_DISPLAY_FLOW_STEP: Pick<IFlowEventData, 'flowStep'> = {
    flowStep: 'redeem successful'
};

export const SUCCESS_DISPLAY_ACTION = 'redeem successful : redeemed';
